import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import { Icon } from "../../ui";
import "./legal.css";

const DataCollectionPage = lazy(() => import("./data-collection").then((m) => ({ default: m.DataCollectionPage })));
const LegalDocPage = lazy(() => import("./doc").then((m) => ({ default: m.LegalDocPage })));
const LegalPage = lazy(() => import("./overview").then((m) => ({ default: m.LegalPage })));
const LegalRequestPage = lazy(() => import("./request").then((m) => ({ default: m.LegalRequestPage })));
const LegalRequestsPage = lazy(() => import("./requests").then((m) => ({ default: m.LegalRequestsPage })));
const LegalSettings = lazy(() => import("./settings").then((m) => ({ default: m.LegalSettings })));

/**
 * Legal and privacy: the business's documents, what it collects, and people's requests about their information.
 * It lives under Settings (Settings › Legal and privacy), so it has no sidebar item; its pages are at /legal.
 */

export const routes: SolutionRoute[] = [
  { solution: "legal", path: "legal", element: <LegalPage /> },
  { solution: "legal", path: "legal/data-collection", element: <DataCollectionPage /> },
  { solution: "legal", path: "legal/requests", element: <LegalRequestsPage /> },
  { solution: "legal", path: "legal/requests/:id", element: <LegalRequestPage /> },
  { solution: "legal", path: "legal/:doc", element: <LegalDocPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "legal", key: "legal", label: "Legal and privacy", icon: Icon.lock, need: "legal.view", Component: LegalSettings }];
